let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lpMXH")).then(() => parcelRequire('29mfh'));